import EditImage from './EditImage';

export default EditImage;
